import classes from './index.module.scss';

export const COLORS = {
    GREY: 'grey',
    GREEN: 'green',
};

export const COLOR_CLASSES = {
    [COLORS.GREY]: classes.grey,
    [COLORS.GREEN]: classes.green,
};
